import { injectable } from "inversify";
import DashboardRepository from "../../repositories/dashboard.repository";
import ErrorEntity from "../../entities/error.entity";
import { Either } from "fp-ts/lib/Either";
import ClientAnalysisEntity from "../../entities/client_analysis.entity";
import QACommentEntity from "../../entities/qa_comment.entity";
import UserProvider from "../../providers/user/UserProvider";

interface props {
    dashboardRepository: DashboardRepository;
    userProvider: UserProvider;
}

@injectable()
class AddCommentToAnalysisUseCase {
    private dashboardRepository: DashboardRepository;
    private userProvider: UserProvider;

    constructor({ dashboardRepository, userProvider }: props) {
        this.dashboardRepository = dashboardRepository;
        this.userProvider = userProvider;
    }

    public call = async (_:{employeeID: string, comment: string}): Promise<Either<ErrorEntity, QACommentEntity>> => {
        const tempComment:QACommentEntity = {
            comment: _.comment,
            date: new Date(),
            id: "",
            user: this.userProvider.Actions.user!,
        }
        return this.dashboardRepository.addComment({
            employeeID: _.employeeID,
            comment: tempComment
        });
    }
}

export default AddCommentToAnalysisUseCase;

export const AddCommentToAnalysisUseCaseName = "AddCommentToAnalysisUseCase";